import { GenericRepository } from "../generic-repository/GenericRepository";
import { environment } from "src/environments/environment";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { IPOSOrderHistoryRepository } from "./IPOSOrderHistoryRepository";
import { ResponseModel } from "../../models/SharedModels/response.model";
import { POSSalesInvoiceSelectTableDto } from "src/app/models/POSModels/POSSalesInvoiceSelectTableDto";

@Injectable({
    providedIn: "root"
})
export class POSOrderHistoryRepository
    extends GenericRepository<POSSalesInvoiceSelectTableDto>
    implements IPOSOrderHistoryRepository {

    private baseUrl: string = environment.urlAddress.endsWith('/')
        ? environment.urlAddress
        : environment.urlAddress + '/';

    constructor(protected _http: HttpClient) {
        super(_http, 'api/PosOrders', environment.urlAddress);
    }

    LoadNavRec(navType: number, currentIndex: number): Observable<ResponseModel> {
        const url = `${this.baseUrl}api/PosOrders/NavRec/${navType}/${currentIndex}`;
        return this._http.get<ResponseModel>(url)
            .pipe(map(this.extractData), catchError(this.handleError));
    }

    LoadRec(code: string, invoiceType: number, billId: string, fiscalSpanID: number): Observable<ResponseModel> {
        const url = `${this.baseUrl}api/PosOrders/LoadRec/${code}/${invoiceType}/${billId}/${fiscalSpanID}`;
        return this._http.get<ResponseModel>(url)
            .pipe(map(this.extractData), catchError(this.handleError));
    }

    GetAll(currentPage: number, recordsPerPage: number, filterText: string): Observable<any> {
        filterText = filterText.split('/').join('~');
        if (filterText === "") {
            filterText = "|";
        }
        const url = `${this.baseUrl}api/PosOrders/SelectAll/${currentPage}/${recordsPerPage}/${filterText}`;
        return this._http.get(url)
            .pipe(map(this.extractData), catchError(this.handleError));
    }

    ProcessInvoice(code: string): Observable<any> {
        const url = `${this.baseUrl}api/PosOrders/ProcessInvoice/${code}`;
        return this._http.get(url)
            .pipe(map(this.extractData), catchError(this.handleError));
    }


    SaveRec(item: any): Observable<ResponseModel> {
        const url = `${this.baseUrl}api/PosOrders/SaveRec`;
        return this._http.post<ResponseModel>(url, item, this.httpOptions)
            .pipe(map(this.extractData), catchError(this.handleError));
    }

    SaveAccountRec(item: any): Observable<ResponseModel> {
        const url = `${this.baseUrl}api/PosOrders/SaveAccountRec`;
        return this._http.post<ResponseModel>(url, item, this.httpOptions)
            .pipe(map(this.extractData), catchError(this.handleError));
    }


    DeleteRec(code: string): Observable<ResponseModel> {
        const url = `${this.baseUrl}api/PosOrders/DeleteRec/${code}`;
        return this._http.delete<ResponseModel>(url, this.httpOptions)
            .pipe(map(this.extractData), catchError(this.handleError));
    }

    DeleteMUlRec(code: string): Observable<ResponseModel> {
        const url = `${this.baseUrl}api/PosOrders/DeleteMulRec/${code}`;
        return this._http.delete<ResponseModel>(url, this.httpOptions)
            .pipe(map(this.extractData), catchError(this.handleError));
    }


}